import React from "react";

import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { useStrings } from "../../localization/localizationHelpers";
import { Modal } from "../Modal/Modal";
import * as styles from "./UnsavedChangesModal.module.css";

type UnsavedChangesModalProps = Readonly<{
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}>;

export const UnsavedChangesModal = ({ isOpen, onLeave, onStay }: UnsavedChangesModalProps) => {
  const [title, description, stayButton, leaveButton] = useStrings(
    "unsavedChangesTitle",
    "unsavedChangesDescription",
    "unsavedChangesStayButton",
    "unsavedChangesLeaveButton"
  );
  const titleId = "unsaved-changes-title";

  return (
    <Modal isOpen={isOpen} onClose={onStay} ariaLabelledBy={titleId}>
      <div className={styles.modalBody}>
        <h2 id={titleId} className={styles.title}>
          {title}
        </h2>
        <p className={styles.description}>{description}</p>
        <div className={styles.buttonRow}>
          <BasicButton
            as="button"
            buttonType={ButtonType.Secondary}
            className={styles.button}
            onClick={onStay}
            type="button"
          >
            {stayButton}
          </BasicButton>
          <BasicButton
            as="button"
            buttonType={ButtonType.Brand}
            className={styles.button}
            onClick={onLeave}
            type="button"
          >
            {leaveButton}
          </BasicButton>
        </div>
      </div>
    </Modal>
  );
};
